import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=8cbb4b52&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=8cbb4b52&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cbb4b52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cbb4b52')) {
      api.createRecord('8cbb4b52', component.options)
    } else {
      api.reload('8cbb4b52', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=8cbb4b52&scoped=true", function () {
      api.rerender('8cbb4b52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/six/Main.vue"
export default component.exports